import { createFileRoute, Link } from '@tanstack/react-router'
import { useState } from 'react'
import { api } from '../lib/api'
import { useMessages } from '@/i18n/messages'
import { forgotPasswordMessages } from '@/i18n/text/forgotPassword'

export const Route = createFileRoute('/forgot-password')({
  component: ForgotPasswordPage,
})

function ForgotPasswordPage() {
  const m = useMessages(forgotPasswordMessages)
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setLoading(true)
    try {
      // The API always resolves ok (never reveals whether the email exists), so
      // we show the same confirmation regardless of the outcome.
      await api.forgotPassword(email.trim())
    } catch {
      // ignore — still show the generic confirmation
    } finally {
      setLoading(false)
      setSent(true)
    }
  }

  return (
    <div className="max-w-md mx-auto px-6 py-16">
      <h1 className="text-2xl font-bold text-slate-900">{m.title}</h1>
      <p className="mt-2 text-sm text-slate-500">
        {m.intro}
      </p>

      {sent ? (
        <div className="mt-8 space-y-4">
          <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-5 text-sm text-emerald-900">
            {m.sent}
          </div>
          <Link to="/login" className="inline-block text-sm text-emerald-700 underline hover:text-emerald-900">
            {m.backToLogin}
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="mt-8 space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700">{m.email}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
              className="mt-1 w-full rounded border border-slate-300 px-3 py-2 text-sm focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 outline-none"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 text-white font-medium rounded px-4 py-2 transition"
          >
            {loading ? m.sending : m.sendResetLink}
          </button>

          <div className="text-center">
            <Link to="/login" className="text-sm text-emerald-700 underline hover:text-emerald-900">
              {m.backToLogin}
            </Link>
          </div>
        </form>
      )}
    </div>
  )
}
